import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken } from "./adminCrud";

export const actionTypes = {
    AdminRequested: "[Request admin] Action",
    AdminUpdated: "[Update admin] Action",
};

const initialAdminState = {
    user: undefined,
    admin: undefined,
    actionsLoading: true
};

export const reducer = persistReducer(
    { storage, key: "trendyol-key", whitelist: ["admin"] },
    (state = initialAdminState, action) => {
        switch (action.type) {
            case actionTypes.AdminRequested: {
                const { user, admin } = action.payload;
                state.actionsLoading = false;
                return { ...state, user, admin };
            }
            case actionTypes.AdminUpdated: {
                const { user, admin } = action.payload;
                return { ...state, user, admin };
            }

            default:
                return state;
        }
    }
);

export const actions = {
    requestAdmin: (user, admin) => ({ type: actionTypes.AdminRequested, payload: { user, admin } }),
    fulfillAdmin: data => ({ type: actionTypes.AdminUpdated, payload: { data } }),
};

export function* saga() {
    yield takeLatest(actionTypes.AdminRequested, function* requestAdmin() {
        const { data : response } = yield getUserByToken();

        yield put(actions.fulfillAdmin(response.data));
    });

    yield takeLatest(actionTypes.AdminUpdated, function* requestAdmin() {
        const { data : response } = yield getUserByToken();

        yield put(actions.fulfillAdmin(response.data));
    });
}
